import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "table-title" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Table = _resolveComponent("Table");
    return (_openBlock(), _createElementBlock("div", null, [
        (_ctx.jobStatusInfos[0][1].length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: { "margin-top": "-6px" },
                class: "text-primary cancel-pending-btn me-2",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.cancelAll()))
            }, " Cancel All "))
            : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allTableData, (tableData, idx) => {
            return (_openBlock(), _createElementBlock("span", { key: idx }, [
                (_ctx.isTableVisible(idx))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                        (tableData && tableData.rows.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(_component_Table, {
                                    tableData: tableData,
                                    caption: _ctx.jobStatusInfos[idx][0],
                                    onCancelJob: _ctx.cancelJob,
                                    noFixedTable: true,
                                    initialSortColumnName: "Start",
                                    initialSortOrder: "desc",
                                    downloadFilenameBase: _ctx.jobStatusInfos[idx][0]
                                }, null, 8, ["tableData", "caption", "onCancelJob", "downloadFilenameBase"])
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.jobStatusInfos[idx][0]), 1),
                                _cache[1] || (_cache[1] = _createElementVNode("p", { style: { "font-size": "14px" } }, "(Queue empty)", -1))
                            ]))
                    ]))
                    : _createCommentVNode("", true)
            ]));
        }), 128))
    ]));
}
